const components = new Map()
import { path } from 'ramda'

components.set('title', ctx => {
  return {
    label: ctx.$t('title'),
    key: 'title',
    component: 'Input',

    options: {
      size: 2,
      validation: 'required|max:30',
    },
  }
})
components.set('description', ctx => {
  return {
    label: ctx.$t('description'),
    key: 'description',
    component: 'RichText',
    options: {
      size: 2,
      collapsible: true,
    },
  }
})
components.set('receivers', ctx => {
  return {
    label: ctx.$tc('receiver', 2),
    key: 'receivers',
    isList: true,
    expanded: true,
    settings: `PrismEditor:condition:${ctx.$t('conditionsMessage')}`,
    component: [
      {
        component: 'Select',
        key: 'user',
        label: ctx.$tc('user', 1),
      },
    ],
    options: {
      minWidth: '500px',
      size: 2,

      layout: 'user',
      settingsLayout: 'condition',
      props: {
        user: {
          items: '/api/resource/user',
        },
        condition: {
          disabled: !Boolean(ctx.$store.getters.isDeveloper),
          sublabel: ctx.$t('usedForDevelopers'),
        },
      },
    },
  }
})

components.set('placement', ctx => {
  function getBlock(value) {
    return `${ctx.onModel.toLowerCase()}-${value}`
  }
  return {
    component: 'CombineSelector',
    label: ctx.$t('formPlacement'),
    i18n: true,
    key: 'placement',
    isList: true,
    options: {
      collapsible: true,

      showLabelCount: false,
      size: 2,
      condition: null,
      props: {
        'hide-result': true,
        seperator: ':',
        categories: [
          {
            key: 'view',
            label: ctx.$tc('page', 1),
            combineWith: 'all',
          },
          {
            key: 'block',
            label: ctx.$t('formPlacementBlock'),
            combineWith: 'all',
          },
        ],

        items: [
          {
            title: ctx.$t('allPages'),
            id: 'all-pages',
            category: 'view',
            icon: ['fal', 'rectangle-history-circle-plus'],
          },
          {
            title: ctx.$t('mainPage'),
            id: 'home',
            category: 'view',
            icon: ['fal', 'globe'],
          },
          ctx.onModel === 'Project'
            ? {
                title: ctx.$tc('unitPage', 2),
                id: 'residential',
                category: 'view',
                icon: ['fal', 'home'],
              }
            : null,

          ctx.onModel === 'Page'
            ? {
                title: ctx.$t('contactPage'),
                id: 'contact',
                category: 'view',
                icon: ['fal', 'id-card'],
              }
            : null,
          {
            title: ctx.$tc('unitCatalog', 2),
            category: 'view',
            icon: ['fal', 'puzzle-piece'],
            id: `${ctx.onModel.toLowerCase()}-residential-template`,
          },
          {
            url: `/api/resource/post?field.id=slug&field.thumbnail=media.cover&field.title=title&references=${ctx.reference}&disableFilterByIds=true`,
            category: 'view',
          },
          {
            title: ctx.$t('topOfThePage'),
            id: getBlock('top'),
            category: 'block',
          },
          {
            title: ctx.$t('bottomOfThePage'),
            id: getBlock('bottom'),
            category: 'block',
          },

          {
            title: ctx.$t('replaceLeadForm'),
            id: getBlock('lead'),
            category: 'block',
          },
          {
            title: ctx.$t('custom'),
            id: 'custom',
            category: 'block',
          },
        ].filter(Boolean),
      },
    },
  }
})

components.set('fields', ctx => ({
  label: ctx.$tc('field', 2),
  key: 'fields',
  isList: true,
  settings: `Radio:size:${ctx.$t('fieldSize')},Checkbox:hide-label:${ctx.$t('hideQuestion')},Input:key:${ctx.$t(
    'identifier',
  )},PrismEditor:condition:${ctx.$t('conditionsMessage')},Input:fontSize:${ctx.$t(
    'adjustFontSize',
  )},SelectList:fontWeight:${ctx.$t('selectThickness')}(font weight)`,
  component: [
    {
      key: 'label',
      component: 'Input',
      label: ctx.$t('question'),
    },
    {
      key: 'placeholder',
      component: 'Input',
      label: ctx.$t('placeholderText'),
    },
    {
      key: 'required',
      component: 'SelectList',
      label: ctx.$t('required'),
    },
    {
      key: 'component',
      component: 'Select',
      label: ctx.$t('fieldType'),
      options: {
        validation: 'required',
      },
    },

    {
      key: 'postplace',
      label: ctx.$t('postplace'),
      component: [
        {
          component: 'Checkbox',
          key: 'include',
          label: ctx.$t('includePostplace'),
        },
        {
          component: 'Input',
          key: 'placeholder',
          label: ctx.$t('placeholderText'),
        },
        {
          component: 'Input',
          key: 'label',
          label: ctx.$t('question'),
        },
        {
          component: 'Input',
          key: 'key',
          label: ctx.$t('identifier'),
        },
      ],
      options: {
        condition: {},
        collapsible: true,
        layout: 'include . . | label placeholder key',
        props: {
          key: {
            disabled: !Boolean(ctx.$store.getters.isDeveloper),
            default: 'postplace',
          },
        },
      },
    },
    {
      key: 'header',
      label: '',
      component: [
        {
          component: 'Input',
          key: 'title',
          label: ctx.$t('title'),
        },
        {
          component: 'RichText',
          key: 'description',
          label: ctx.$t('description'),
        },
      ],
      options: {
        layout: 'title | description',
        props: {
          _parent: {
            noPadding: true,
          },
        },
      },
    },

    {
      key: 'options',
      label: ctx.$tc('alternative', 2),
      isList: true,
      component: [
        {
          key: 'option',
          component: 'Input',
          label: ctx.$tc('alternative', 1),
        },
        {
          key: 'key',
          component: 'Input',
          label: ctx.$t('identifier'),
        },
      ],
      options: {
        layout: 'option option key',
        props: {
          key: {
            disabled: !Boolean(ctx.$store.getters.isDeveloper),
            sublabel: ctx.$t('usedForDevelopers'),
          },
          option: {
            sublabel: ctx.$t('addAlternative'),
          },
        },
      },
    },
    {
      key: 'position-theme',
      component: 'Select',
      label: ctx.$t('selectMapTheme'),
      options: {
        props: {
          items: [
            {
              title: ctx.$t('standard'),
              id: 'standard',
              thumbnail: 'https://assets.kvass.no/65d60909251ded28d9509664',
            },
            {
              title: ctx.$t('dark'),
              id: 'dark',
              thumbnail: 'https://assets.kvass.no/65d60a780fa5bd796f0b4a4f',
            },
            {
              title: ctx.$t('light'),
              id: 'light',
              thumbnail: 'https://assets.kvass.no/65d60a070fa5bd796f0b49b7',
            },
          ],
        },
      },
    },
    {
      key: 'lead-placeholder',
      label: ctx.$t('placeholderText'),
      component: [
        {
          key: 'name',
          component: 'Input',
          label: ctx.$t('name'),
        },
        {
          key: 'email',
          component: 'Input',
          label: ctx.$t('email'),
        },
        {
          key: 'phone',
          component: 'Input',
          label: ctx.$t('phone'),
        },
        {
          key: 'comment',
          component: 'Input',
          label: ctx.$tc('message', 1),
        },
      ],
      options: {
        collapsible: true,
        layout: 'name email phone comment',
      },
    },
    {
      key: 'lead-label',
      label: ctx.$t('title'),
      component: [
        {
          key: 'name',
          component: 'Input',
          label: ctx.$t('name'),
        },
        {
          key: 'email',
          component: 'Input',
          label: ctx.$t('email'),
        },
        {
          key: 'phone',
          component: 'Input',
          label: ctx.$t('phone'),
        },
        {
          key: 'comment',
          component: 'Input',
          label: ctx.$tc('message', 1),
        },
      ],
      options: {
        collapsible: true,
        layout: 'name email phone comment',
      },
    },
  ],
  options: {
    size: 2,
    layout:
      'component label placeholder required | position-theme position-theme position-theme position-theme | lead-placeholder lead-placeholder lead-placeholder lead-placeholder | lead-label lead-label lead-label lead-label | header header header header | options options options options | postplace postplace postplace postplace',
    settingsLayout: 'hide-label hide-label | size size | key condition | fontSize fontWeight',
    expanded: true,
    condition: {
      fontWeight: {
        'fields.component': {
          $nin: ['header'],
        },
      },
      fontSize: {
        'fields.component': {
          $nin: ['header'],
        },
      },
      header: {
        'fields.component': 'header',
      },
      placeholder: {
        'fields.component': {
          $in: ['email', 'short-text', 'long-text', 'postcode'],
        },
      },
      label: {
        'fields.component': {
          $nin: ['lead', 'header'],
        },
      },
      required: {
        'fields.component': {
          $nin: ['lead', 'privacy', 'header'],
        },
      },

      options: {
        'fields.component': {
          $in: ['radio', 'dropdown', 'checklist'],
        },
      },
      'lead-placeholder': {
        'fields.component': {
          $in: ['lead'],
        },
      },
      'lead-label': {
        'fields.component': {
          $in: ['lead'],
        },
      },
      'position-theme': {
        'fields.component': {
          $in: ['position'],
        },
      },
      postplace: {
        'fields.component': {
          $in: ['postcode'],
        },
      },
    },
    props: {
      condition: {
        disabled: !Boolean(ctx.$store.getters.isDeveloper),
        sublabel: ctx.$t('usedForDevelopers'),
      },
      key: {
        disabled: !Boolean(ctx.$store.getters.isDeveloper),
        sublabel: ctx.$t('usedForDevelopers'),
      },
      fontSize: {
        suffix: 'px',
      },
      fontWeight: {
        items: [
          {
            id: 300,
            label: 'thin',
          },
          {
            id: 400,
            label: 'normal',
          },
          {
            id: 500,
            label: 'semiBold',
          },
          {
            id: 600,
            label: 'bold',
          },
          {
            id: 700,
            label: 'extraBold',
          },
        ],
      },
      size: {
        default: 'full',
        items: [
          {
            label: ctx.$t('fullWidth'),
            value: 'full',
            icon: 'fa-pro-solid:rectangle-wide',
          },

          {
            label: ctx.$t('halfWidth'),
            value: 'half',
            icon: 'fa-pro-solid:rectangle-vertical',
          },
        ],
      },
      required: {
        items: [
          {
            label: ctx.$t('yes'),
            value: 'yes',
          },
          {
            label: ctx.$t('no'),
            value: 'no',
          },
        ],
      },
      component: {
        items: [
          {
            label: ctx.$tc('lead', 1),
            id: 'lead',
            icon: 'fa-pro-light:image-user',
          },
          {
            label: ctx.$t('shortText'),
            id: 'short-text',
            icon: 'fa-pro-light:text',
          },
          {
            label: ctx.$t('email'),
            id: 'email',
            icon: 'fa-pro-light:at',
          },
          {
            label: ctx.$t('phone'),
            id: 'phone',
            icon: 'fa-pro-light:phone',
          },

          {
            label: ctx.$t('paragraph'),
            id: 'long-text',
            icon: 'fa-pro-light:align-justify',
          },
          {
            label: ctx.$t('multipleChoice'),
            id: 'radio',
            icon: 'fa-pro-light:list-radio',
          },
          {
            label: ctx.$tc('checkbox', 2),
            id: 'checklist',
            icon: 'fa-pro-light:list',
          },
          {
            label: ctx.$t('dropdownMenu'),
            id: 'dropdown',
            icon: 'fa-pro-light:list-dropdown',
          },
          {
            label: ctx.$t('fileUpload'),
            id: 'file',
            icon: 'fa-pro-light:file',
          },
          {
            label: ctx.$t('privacyPolicy'),
            id: 'privacy',
            icon: 'fa-pro-light:user-lock',
          },
          {
            label: ctx.$tc('checkbox', 1),
            id: 'checkbox',
            icon: 'fa-pro-light:check',
          },
          {
            label: ctx.$t('number'),
            id: 'number',
            icon: 'fa-pro-light:hashtag',
          },
          {
            label: ctx.$t('date'),
            id: 'date',
            icon: 'fa-pro-light:calendar-days',
          },
          {
            label: ctx.$t('postcode'),
            id: 'postcode',
            icon: 'fa-pro-light:mailbox',
          },

          {
            label: ctx.$t('titleAndDescription'),
            id: 'header',
            icon: 'fa-pro-light:text-size',
          },
          {
            label: ctx.$t('position'),
            id: 'position',
            icon: 'fa-pro-light:map-location-dot',
          },
        ],
      },
    },
  },
}))

components.set('settings', ctx => {
  return {
    label: ctx.$t('settings'),
    key: 'settings',
    settings: `YesNoSwitch:addSectionWrapper:${ctx.$t('addFormInASection')},SelectList:sectionTheme:${ctx.$t(
      'sectionTheme',
    )},SelectList:sectionWidth:${ctx.$t('sectionWidth')},PrismEditor:layout:Layout,Radio:contentLayout:${ctx.$t(
      'contentLayout',
    )},Radio:successBehavior:${ctx.$t('successBehavior')},SelectList:formWidth:${ctx.$t(
      'formWidth',
    )},SelectList:formPlacement:${ctx.$t('formPlacement')},Input:marginBlock:${ctx.$t(
      'spacingBetweenRows',
    )},Input:marginInline:${ctx.$t('spacingBetweenColumns')},URL:submitEndpoint:${ctx.$t('apiEndpointForSubmission')}`,
    component: [
      {
        component: 'YesNoSwitch',
        key: 'hide-title',
        label: `${ctx.$t('hide')} ${ctx.$t('title').toLowerCase()}`,
      },
      {
        component: 'YesNoSwitch',
        key: 'center-heading',
        label: ctx.$t('centerText'),
      },
      {
        component: 'RichText',
        key: 'success-message',
        label: ctx.$t('submissionConfirmation'),
      },
      {
        component: 'Input',
        key: 'submit-button-label',
        label: ctx.$t('submitButton'),
      },
      {
        component: 'Input',
        key: 'restart-button-label',
        label: ctx.$t('restartButton'),
      },
      {
        component: 'YesNoSwitch',
        key: 'enable-email-confirmation',
        label: ctx.$t('formSubmitEnableEmailConfirmation'),
      },
      {
        component: 'Input',
        key: 'email-confirmation-subject',
        label: ctx.$t('formSubmitEmailConfirmationSubjectLabel'),
      },
      {
        component: 'RichText',
        key: 'email-confirmation-message',
        label: ctx.$t('formSubmitEmailConfirmationMessageLabel'),
      },
      {
        component: 'Media',
        key: 'email-confirmation-logo',
        label: ctx.$t('formSubmitEmailConfirmationLogo'),
      },
    ],
    options: {
      collapsible: true,
      size: 2,
      layout:
        'hide-title | center-heading | success-message | submit-button-label | restart-button-label | enable-email-confirmation | email-confirmation-subject | email-confirmation-message | email-confirmation-logo',
      settingsLayout:
        'layout layout | contentLayout contentLayout | successBehavior successBehavior | addSectionWrapper addSectionWrapper | sectionTheme sectionWidth | formWidth formPlacement | marginBlock marginInline | submitEndpoint submitEndpoint',
      condition: {
        formPlacement: {
          placement: {
            $not: /(page|project)-lead$/,
          },
        },
        addSectionWrapper: {
          placement: {
            $not: /(page|project)-lead$/,
          },
        },

        sectionTheme: {
          'settings.addSectionWrapper': true,
        },
        sectionWidth: {
          'settings.addSectionWrapper': true,
        },

        'restart-button-label': {
          'settings.successBehavior': 'replaceForm',
        },
        'enable-email-confirmation': {
          'fields.component': { $in: ['lead', 'email'] },
        },
        'email-confirmation-subject': {
          'settings.enable-email-confirmation': true,
          'fields.component': { $in: ['lead', 'email'] },
        },
        'email-confirmation-message': {
          'settings.enable-email-confirmation': true,
          'fields.component': { $in: ['lead', 'email'] },
        },
      },
      props: {
        'success-message': {
          default: ctx.$t('leadMessageSent'),
          style: 'margin-top: 1rem;',
        },
        'submit-button-label': {
          default: ctx.$t('submit', { x: '' }),
        },
        'restart-button-label': {
          default: ctx.$t('goBack'),
        },
        'enable-email-confirmation': {
          default: false,
        },
        'email-confirmation-logo': {
          placement: 'inside',
          size: 'contain',
          style: 'height: 200px;',
          uploadOptions: { compression: 'logo' },
          enableDescription: false,
          enableAlt: false,
          types: ['Image'],
        },
        submitEndpoint: {
          disabled: !Boolean(ctx.$store.getters.isDeveloper),
        },
        layout: {
          disabled: !Boolean(ctx.$store.getters.isDeveloper),
        },
        contentLayout: {
          default: 'vertical',
          items: [
            {
              label: ctx.$t('vertical'),
              value: 'vertical',
              icon: 'fa-pro-solid:table-rows',
            },
            {
              label: ctx.$t('horizontal'),
              value: 'horizontal',
              icon: 'fa-pro-solid:table-columns',
            },
          ],
        },
        successBehavior: {
          default: 'keepForm',
          items: [
            {
              label: ctx.$t('successBehaviorKeepForm'),
              value: 'keepForm',
              icon: 'fa-pro-solid:arrows-rotate',
            },
            {
              label: ctx.$t('successBehaviorReplaceForm'),
              value: 'replaceForm',
              icon: 'fa-pro-solid:right-left',
            },
          ],
        },
        marginBlock: {
          suffix: 'px',
        },
        marginInline: {
          suffix: 'px',
        },
        formPlacement: {
          default: 'center',
          items: [
            {
              id: 'center',
              label: ctx.$t('centered'),
            },
            {
              id: 'left',
              label: ctx.$t('left'),
            },
          ],
        },
        formWidth: {
          default: '700',
          items: [
            {
              id: '700',
              label: '700px',
            },
            {
              id: '1000',
              label: '1000px',
            },
            {
              id: '1200',
              label: '1200px',
            },
            {
              id: 'initial',
              label: ctx.$t('none'),
            },
          ],
        },
        sectionWidth: {
          default: 'medium',
          items: [
            {
              id: 'small',
              label: ctx.$t('small'),
            },
            {
              id: 'medium',
              label: ctx.$t('medium'),
            },
            {
              id: 'large',
              label: ctx.$t('large'),
            },
            {
              id: 'full',
              label: ctx.$t('full'),
            },

            {
              id: 'none',
              label: ctx.$t('none'),
            },
          ],
        },
        sectionTheme: {
          default: 'none',
          items: [
            {
              id: 'primary',
              label: ctx.$t('primaryColor'),
            },
            {
              id: 'secondary',
              label: ctx.$t('secondaryColor'),
            },
            {
              id: 'custom',
              label: ctx.$t('customColor'),
            },
            {
              id: 'none',
              label: ctx.$t('none'),
            },
          ],
        },
      },
    },
  }
})

export default components
